import React, { createContext, useContext } from 'react';
import useQueryPretaxAccounts from 'hooks/useQueryPretaxAccounts';
import useQueryPretaxDependents from 'hooks/useQueryPretaxDependents';

import ProfileContext from 'contexts/ProfileContext';
import {
  ENROLL_PENDING_PRETAX_COMMUTER_ACCOUNT,
  PRETAX_COMMUTER_ENROLL_STATUS,
} from 'constants/accounts';
import { findIndex } from 'lodash';

import { PretaxAccount, PretaxDependent } from './types';

interface PretaxContextInterface {
  pretax_accounts: Array<PretaxAccount>;
  pretax_dependents: Array<PretaxDependent>;
  is_loading_pretax: boolean;
}

const PretaxContext = createContext<PretaxContextInterface>({
  pretax_accounts: [],
  pretax_dependents: [],
  is_loading_pretax: true,
});

export const PretaxContextProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const {
    employee: {
      settings: {
        is_cdh_enabled,
        pretax_commuter_status = PRETAX_COMMUTER_ENROLL_STATUS.SELECIION_DISABLED,
      },
    },
    company: {
      features: { pretax_config = { twic_commuter: false } },
    },
  } = useContext(ProfileContext);
  const { data: pretax_accounts_data, is_loading: is_pretax_accounts_loading } =
    useQueryPretaxAccounts({ is_cdh_enabled });
  const {
    data: pretax_dependents_data,
    is_loading: is_pretax_dependents_loading,
  } = useQueryPretaxDependents({ is_cdh_enabled });

  const pretax_accounts = pretax_accounts_data?.pretax_accounts || [];
  const pretax_dependents = pretax_dependents_data?.pretax_dependents || [];
  const commuter_pending_enroll =
    pretax_config.twic_commuter &&
    pretax_commuter_status === PRETAX_COMMUTER_ENROLL_STATUS.SELECTION_PENDING;
  if (
    commuter_pending_enroll &&
    findIndex(
      pretax_accounts,
      (a: PretaxAccount) =>
        a.flex_account_id ===
        ENROLL_PENDING_PRETAX_COMMUTER_ACCOUNT.flex_account_id
    ) === -1
  ) {
    pretax_accounts.push(
      ENROLL_PENDING_PRETAX_COMMUTER_ACCOUNT as PretaxAccount
    );
  }

  return (
    <PretaxContext.Provider
      value={{
        pretax_accounts,
        pretax_dependents,
        is_loading_pretax:
          is_pretax_accounts_loading || is_pretax_dependents_loading,
      }}
    >
      {children}
    </PretaxContext.Provider>
  );
};

export default PretaxContext;
